import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/article/[slug]/_components/BrandNew212Swiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/article/[slug]/_components/ExitIntentScrollPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/article/[slug]/_components/NewCarsSwiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/article/[slug]/_components/ScrollDepthTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/article/[slug]/_components/ScrollNewsletterPopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/article/[slug]/_components/SocialSharePopup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/contact-us/components/LocationMapCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/audio/AudioPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/images/OptimizedImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/homes-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/innovation-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/jobs-logo.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/ravo-logo.png");
